import { put, takeLatest } from "redux-saga/effects";
import { requestCreditNoteDetailsReportsList } from "services/acclgl/reports/creditNoteDetailReports";
import {
  fetchCreditNoteDetailsReportsListRequest,
  fetchCreditNoteDetailsReportsListSuccess,
  fetchCreditNoteDetailsReportsListFailure,
   
} from "redux/reducers/acclgl/reports/creditNoteDetailsReports";
export function* watchCreditNoteDetailsReportsSaga() {
  yield takeLatest(fetchCreditNoteDetailsReportsListRequest, fetchCreditNoteDetailsReportsList);
}

function* fetchCreditNoteDetailsReportsList({ payload }) {
  try {
    const response = yield  requestCreditNoteDetailsReportsList(payload);
    yield put(fetchCreditNoteDetailsReportsListSuccess(response));
  } catch (error) {
    yield put(
      fetchCreditNoteDetailsReportsListFailure("Failed to get list of reports")
    );
  }
}
